import { useProductAPI } from "../../../api/product/useProductAPI";
import { productInActions } from "./ProductInReducer";


export const useProductIn= () => {
    const api = useProductAPI();
  
    const request = {
        get: (params) => {
          return async (dispatch) => {
            try {
              const response = await api.productIn.get(params);
              dispatch(productInActions.funGetProductIn(response));
            } catch (error) {
              console.error('Error fetching data:', error);
            }
          }
        },
        post: async (data) => {
          return await api.productIn.post(data);
        },
        put: async (data) => {
          return await api.productIn.put(data);
        },
        delete: async (params) => {
          return await api.productIn.delete(params);
        }
    };
    return { request };
  };